module.exports = __webpack_public_path__ + "static/media/ico-getnet.533bfc3c.svg";